export enum Action {
  Deploy = 'deploy',
  Undeploy = 'undeploy',
}
